module.exports = __webpack_public_path__ + "img/no_image.f3ff3e3a.png";